export default {"src":"/_next/static/media/ubq.5aac9efe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};